// extracted by mini-css-extract-plugin
export default {"warnPrompt":"NeedToChangeRulesBeforeSavePrompt_warnPrompt__EocWA"};